function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.895,76.346c-1.933,0-3.5-1.567-3.5-3.5c0-12.352,7.397-20.069,13.923-26.88 c5.619-5.864,10.473-10.928,10.473-18.07C48.791,16.373,39.417,7,27.895,7C16.373,7,7,16.373,7,27.896c0,1.933-1.567,3.5-3.5,3.5 c-1.933,0-3.5-1.567-3.5-3.5C0,12.513,12.513,0,27.895,0c15.381,0,27.896,12.513,27.896,27.896c0,9.955-6.313,16.543-12.419,22.913 c-6.159,6.428-11.977,12.499-11.977,22.038C31.395,74.778,29.828,76.346,27.895,76.346"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.895,110.298c-3.038,0-5.5-2.462-5.5-5.5v-0.106c0-3.039,2.462-5.5,5.5-5.5s5.5,2.461,5.5,5.5v0.106 C33.395,107.836,30.933,110.298,27.895,110.298"
});

var SvgHelpSupport = function SvgHelpSupport(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 56,
    height: 111,
    viewBox: "-0.172 -0.446 56 111",
    enableBackground: "new -0.172 -0.446 56 111",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHelpSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/helpSupport.1b26cf1a.svg";
export { ForwardRef as ReactComponent };